import BrowserSupport from './BrowserSupport';
export { browser } from './BrowserSupport';
export default BrowserSupport;